
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormater'
})
export class NumberFormater implements PipeTransform {
  transform(num: number) {
    if (!num) {
      return num;
    }
    if (num >= 1000000) {
      return this.intlFormat(num / 1000000) + 'M';
    }
    if (num >= 10000) {
      return this.intlFormat(num / 1000) + 'k';
    }
    return this.intlFormat(num);
  }

  private intlFormat(num: number) {
    return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
  }
}
